import React from 'react';
import components from '../../../components';
import './main.css';
import FontAwesomeIcon from '@fortawesome/react-fontawesome';
import faLinkedin from '@fortawesome/fontawesome-free-brands/faLinkedin';
import faFacebook from '@fortawesome/fontawesome-free-brands/faFacebook';
import faGithub from '@fortawesome/fontawesome-free-brands/faGithub';
import faGitlab from '@fortawesome/fontawesome-free-brands/faGitlab';
import { Line } from 'rc-progress';
import t from '../../../i8n';
import karol_pgp from './karol_walasek_ovh.asc.js';

let COMPETENCE, SOCIAL_MAP;

function updateData(){
	SOCIAL_MAP = [
		{name: 'LinkedIn', color: '#0776B4', icon: faLinkedin, url: 'https://www.linkedin.com/in/karol-walasek/'},
		{name: 'Facebook', color: '#4467B1', icon: faFacebook, url: 'https://www.facebook.com/karol.walasek'},
		{name: 'GitHub', color: 'black', icon: faGithub, url: 'https://github.com/WalasPrime'},
		{name: 'GitLab', color: '#FCA22A', icon: faGitlab, url: 'https://gitlab.com/coreconviction'}
	];

	COMPETENCE = {
		devops_services: [
			'AWS EC2', 'AWS Lambda', 'OVH VPS', 'Oktawave OCI', 'Tiktalik VPS', 'Aruba VPS', 'Heroku', 'DataDog', 'GitLab CI'
		],
		devops_langs: [
			{name: 'Linux', percent: 90, desc: 'Debian, CentOS'},
			{name: 'Python', percent: 70, desc: t({pl: 'Skrypty automatyzujące', en: 'Automation scripts'})},
			{name: 'Bash', percent: 20, desc: t({pl: 'Skrypty automatyzujące', en: 'Automation scripts'})}
		],
		backend: [
			{name: 'Node.js', percent: 95, desc: 'ES6+, TAP'},
			{name: 'Node.js', percent: 40, desc: 'TypeScript'},
			{name: 'Node.js', percent: 15, desc: 'CoffeScript'},

			{name: 'MongoDB', percent: 35},
			{name: 'SQLite', percent: 40},
			{name: 'MySQL', percent: 15},
			{name: 'PostgreSQL', percent: 35}
		],
		frontend: [
			{name: 'HTML5, CSS3', percent: 70, desc: t({pl: 'Responsywny CSS', en: 'Responsive CSS'})},
			{name: 'React', percent: 65, desc: 'Redux'},
			{name: 'React Native', percent: 30},
			{name: 'Angular (1.x)', percent: 15},
			{name: 'Vue', percent: 15},
			{name: 'WebGL', percent: 50, desc: t({pl: 'Doświadczenie w OpenGL i GLSL', en: 'Experience with OpenGL and GLSL'})},
		]
	}
}

function competenceBarList(list){
	return list.sort((a,b) => b.percent-a.percent).map((c,i) => (
		<div style={{marginTop: 10, marginBottom: 10}} key={i}>
			<div>{c.name}</div>
			<div className="cv-tiny">{c.desc}&nbsp;</div>
			<div style={{marginTop: -10}}><Line percent={c.percent} strokeWidth="2" strokeColor="#286085" trailColor="#FFFFFF" /></div>
		</div>
	));
}

export default
class KontaktScreen extends React.Component {
	constructor(props){
		super(props);
		this.state = {showPGP: false};
	}
	showPGP(){
		this.setState({showPGP: true});
	}
	render(){
		updateData();
		return (
			<div>
				<div className="cv-header">
					<components.Avatar src="avatar.jpg" />
					<h1>Karol Walasek</h1>
					<p>Full-Stack Node.js Web Developer</p>
				</div>
				<div className="cv-social">
				{(SOCIAL_MAP).map((row, i) => (
					<a href={row.url} title={row.name} style={{color: row.color}} key={i}>
						<FontAwesomeIcon icon={row.icon} title={row.name} />
					</a>
				))
				}</div>
				<p className="cv-mail"><img src="gfx/karol-mail.png" /></p>
				<p className="cv-tiny cv-centered">
					{this.state.showPGP
					? <p>{karol_pgp.split('\n').map(l => (
						<span>
							{l} <br />
						</span>
					))}</p>
					: <a style={{cursor: 'pointer'}} onClick={() => this.showPGP()}>
						{t({pl: 'Kliknij, aby pokazać klucz publiczny PGP 501B8228', en: 'Click here to show the public PGP key 501B8228'})}
					</a>}
				</p>
				<div className="cv-competence">
					<div className="cv-competence-grid">
						<div className="cv-competence-cell">
							<div className="cv-competence-cell-content">
								<h3>Ops</h3>
								{competenceBarList(COMPETENCE.devops_langs)}
								<p className="cv-tiny">{t({pl: 'Doświadczenie z:', en: 'Experience with:'})} {COMPETENCE.devops_services.join(', ')}</p>
							</div>
						</div>
						<div className="cv-competence-cell">
							<div className="cv-competence-cell-content">
								<h3>Backend</h3>
								{competenceBarList(COMPETENCE.backend)}
							</div>
						</div>
						<div className="cv-competence-cell">
							<div className="cv-competence-cell-content">
								<h3>Frontend</h3>
								{competenceBarList(COMPETENCE.frontend)}
							</div>
						</div>
						<div className="cv-competence-cell cv-competence-wide">
							<div className="cv-competence-cell-content">
								<h3>Bare metal</h3>
								<p className="cv-tiny">
									{t({
										pl: 'Budowa, serwis i diagnostyka komputerów, instalacja i konfiguracja sprzętu sieciowego, doświadczenie z urządzeniami Raspberry Pi.',
										en: 'Building and servicing PCs, installation and configuration of networking devices, experience with Raspberry Pi devices.'
									})}
								</p>
							</div>
						</div>
					</div>
				</div>
				<p className="cv-tiny">
					{t({
						pl: 'Paski przedstawiają umiejętności lub chęć pracy w danej technologii.',
						en: 'Bars represent skills and the willingness to work with the corresponding technology.'
					})}
				</p>
			</div>
		);
	}
}


// WEBPACK FOOTER //
// ./src/Content/Screens/Kontakt/index.js